module.exports = __webpack_public_path__ + "img/cambridge.7a485e21.png";